import { render, staticRenderFns } from "./EmployeesStatisticBlock.vue?vue&type=template&id=47cf22de&scoped=true&"
import script from "./EmployeesStatisticBlock.vue?vue&type=script&lang=js&"
export * from "./EmployeesStatisticBlock.vue?vue&type=script&lang=js&"
import style0 from "./EmployeesStatisticBlock.vue?vue&type=style&index=0&id=47cf22de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cf22de",
  null
  
)

export default component.exports